// extracted by mini-css-extract-plugin
export var container = "_gi-0";
export var outlet = "_gi-1";
export var outletEnter = "_gi-2";
export var outletEnterActive = "_gi-3";
export var outletExit = "_gi-4";
export var outletExitActive = "_gi-5";